<div class="main-container" *ngIf="!notVerifiedSchoolDetails">
  <div class="sub-container d-flex">
    <div class="background-image" [style.background-image]="brand.id ? 'url(' + brand.loginImagePath + ')' : null">
      <div>
        <div class="welcome-content-overlay" *ngIf="brand.showBrandingText">
          <div class="welcome-message">
            {{ 'welcomeTo' | translate  }}
          </div>
          <div>
            <img *ngIf="brand.id" [src]="brand.nameLogoPath" class="school-name-image" />
          </div>
          <div class="educational-message">
            {{ brand.loginTagline }}
          </div>
        </div>
        <div class="quote-content-overlay welcome-message">
          <div class="quote" *ngIf="brand.loginQuote">
            <div>"{{ brand.loginQuote }}"</div>
            <div class="quote-author" *ngIf="brand.authorNameDisplay && brand.authorName">{{ brand.authorName }}</div>
          </div>
          <div class="quote" *ngIf="!brand.loginQuote && messages[currentIndex]">
            <div>"{{ messages[currentIndex].quote }}"</div>
            <div class="quote-author">{{ messages[currentIndex].author }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="login-main-container">
      
      <div class="help-link-contact">
          <a [ngClass]="{
            'show-help-link': isGoBack,
            'show-and-hide-login-container': !isGoBack
          }"  class="show-help-link-go-back" (click)="handleGoBack()">{{'goBack' | translate }}</a>
          <div class="headerbar-right">
            <app-language-dropdown></app-language-dropdown>
            <a class="show-help-link help-link-header" [href]="brand.helpUrl" target="_blank">{{ 'help' | translate
              }}</a>
          </div>
          </div>
      <div [ngClass]="{
        'login-container': !otpVerificationPage,
        'show-and-hide-login-container': otpVerificationPage || isForgotPassword || isResetPassword
      }">
        <div [ngClass]="{
            'login-sub-container': !showPasswordInput,
            'login-sub-container-password': showPasswordInput 
          }">
          <div class="text-center login-text">
            <app-loader data="" loadingStyle="Dots" *ngIf="!loginSchoolLogo"></app-loader>
            <img src="{{ loginSchoolLogo }}" class="login-w-image school-logo" alt="school-logo"
              *ngIf="loginSchoolLogo" />
          </div>
          <div class="text-center login-heading">
            {{ 'login' | translate  }}
          </div>
          <div class="login-message text-center">
            {{ 'loginWithYourCredentials' | translate  }}
          </div>
          <div class="login-mode-switch" *ngIf="isFranchise === 0">
            <button type="button" class="login-mode-option" [class.active]="!isStaffLogin" (click)="setLoginMode('WEB_ADMIN')">
              {{ 'adminLogin' | translate }}
            </button>
            <button type="button" class="login-mode-option" [class.active]="isStaffLogin" (click)="setLoginMode('STAFF')">
              {{ 'staffLogin' | translate }}
            </button>
          </div>
          <div class="form-group input-login-details email-input-container">
            <label for="url" [ngClass]="{
                'login-label-error': errorMessage.userEmail,
                'login-label': !errorMessage.userEmail
              }">{{ !isStaffLogin ? ('usernameOrEmailId' | translate ) : ('mobileNumberOrEmail' | translate ) }}</label>
            <div class="domain-url-input-group">
              <input type="text" class="form-control" id="text" name="userEmail" [ngClass]="{
                  'email-input': !errorMessage.userEmail,
                  'email-input-error': errorMessage.userEmail
                }" minlength="2" maxlength="90" [(ngModel)]="userEmail" #emailAddress
                placeholder="{{ !isStaffLogin ? ('enterYourUsernameOrEmailId' | translate ) : ('mobileNumberForStaff' | translate )   }}" (input)="handleDebounceEmail(emailAddress)"
                (keyup.enter)="!showPasswordInput ?getOTPForDomainLogin(): ''" />
              <div class="error-message">
                <span *ngIf="errorMessage.userEmail">
                  {{ errorMessage.userEmail }}</span>
              </div>
            </div>
          </div>

          <div class="form-group input-login-details password-visibility" [ngClass]="{
            'password-visibility': showPasswordInput || isForgotPassword || isResetPassword,
            show: showPasswordInput
          }" *ngIf="showPasswordInput">
            <label for="password" [ngClass]="{
              'login-label-error': passwordInput.invalid && passwordInput.touched,
              'login-label': !(passwordInput.invalid && passwordInput.touched)
            }">
              {{ 'password' | translate  }}
            </label>
            <div class="password-input-group">
              <input 
                class="form-control email-input" 
                [ngClass]="{
                  'email-input': !(passwordInput.invalid && passwordInput.touched),
                  'email-input-error': passwordInput.invalid && passwordInput.touched
                }"
                [(ngModel)]="password" 
                #passwordInput="ngModel" 
                name="password" 
                placeholder="{{ 'enterYourPassword' | translate  }}" 
                id="password"
                type="{{passwordType}}" 
                (keyup.enter)="showPasswordInput ? submitPasswordVerification() : ''"
                required
              />
              <span class="password-icon">
                 <img *ngIf="passwordType === 'password'" (click)="changePasswordType()" src="../../assets/img/password-icon.svg" alt="Password Icon" /> 
                 <img *ngIf="passwordType === 'text'" (click)="changePasswordType()" class="open-eye-password"  src="../../assets/img/open-lock.svg" alt="Password Icon" />
              </span>
            </div>
            <div *ngIf="passwordInput.invalid && passwordInput.touched" class="error-message-password">
              <span *ngIf="passwordInput.errors?.['required']">{{ 'passwordCannotBeEmpty' | translate }}</span>
            </div>
            <div class="forgot-password-container" (click)="handleForgotPassword()" *ngIf="isStaffLogin">
              <span class="forgot-password-link">{{ 'forgotPassword' | translate  }}</span>
            </div>
          </div>
                  
          <div class="login-btn text-center">
            <button class="btn btn-otp" type="submit" [disabled]="
                 loader
              " (click)="
                showPasswordInput
                  ? submitPasswordVerification()
                  : getOTPForDomainLogin()
              ">
              <ng-container *ngIf="loader; else notLoadingLogin"><app-button-loader></app-button-loader></ng-container>
              <ng-template #notLoadingLogin>
                {{
                showPasswordInput ? ('login' | translate ) : ('getOTP' | translate )
                }}
              </ng-template>
            </button>
          </div>
          <div class="text-center login-link" *ngIf="!isStaffLogin">
            <span class="login-url-links" (click)="togglePasswordInput()">
              {{
              showPasswordInput
              ? ('loginWithOTP' | translate )
              : ('loginWithPassword' | translate )
              }}</span>
          </div>

          <div class="qr-login-divider" *ngIf="isStaffLogin && brand.staffQrLoginEnabled">
            <span>{{ 'or' | translate }}</span>
          </div>
          <div class="login-btn text-center" *ngIf="isStaffLogin && brand.staffQrLoginEnabled">
            <button type="button" class="btn btn-qr-login" (click)="openQrCodeLogin()">
              <i class="ri-qr-code-line qr-login-icon"></i>
              {{ 'loginWithQrCode' | translate }}
            </button>
          </div>

          <div class="text-center login-link">
            <span>{{ 'notRegistered' | translate  }} </span><span class="login-url-links" (click)="openRegisterLink()">{{
              'register' | translate
              }}</span>
          </div>
        </div>
      </div>

      <!-- OTP Verification -->
      <div [ngClass]="{
        'login-otp-container': otpVerificationPage,
        'show-and-hide-login-container': !otpVerificationPage
      }">
        <div [ngClass]="{
          'login-sub-container': !showPasswordInput,
          'login-sub-container-password': showPasswordInput
        }">
          <div class="text-center login-text">
            <img src="{{ loginSchoolLogo }}" class="login-w-image" />
          </div>
          <div class="text-center" [ngClass]="{
            'login-heading': !showPasswordInput,
            'login-heading-in-password': showPasswordInput
          }">
            {{ 'otpVerification' | translate  }}
          </div>
          <div class="login-message text-center">
            {{ 'otpVerificationMessage' | translate  }}
          </div>
          <div class="input-login-details otp-inputs-container">
            <input *ngFor="let digit of otp; let i = index; trackBy: trackByIndex" id="otp-input-{{ i }}" name="otp-{{ i }}" type="text" maxlength="1"
              class="login-otp-input" [(ngModel)]="otp[i]"
              (keyup)="moveToNext($event, i)" (keydown)="handleKeyDown($event)" autocomplete="off"
              (keyup.enter)="handleVerifyDomainOtpLogin()" />
          </div>
          <div class="text-center">
            <button class="resend-otp-links" type="submit" [disabled]="loader || otpTime > 0 || countdown === 0"
              (click)="resendOtp()">
              {{ 'resendOtp' | translate  }}</button><span class="otp-timer-text">
              {{ 'in' | translate  }} {{ otpTime }} {{ 'sec' | translate  }} ({{
              countdown
              }}
              {{ 'resendAttempts' | translate  }} )</span>
          </div>
          <div class="login-btn text-center">
            <button class="btn btn-otp" type="submit" [disabled]=" loader" (click)="handleVerifyDomainOtpLogin()">
              <ng-container *ngIf="loader; else notLoadingVerify">
                <app-button-loader></app-button-loader>
              </ng-container>
              <ng-template #notLoadingVerify>
                {{ 'login' | translate  }}
              </ng-template>
            </button>
            <div class="text-center login-link">
            </div>
            <div class="text-center login-url-links" (click)="handleOnclickPassword()">
              {{ 'loginWithPassword' | translate  }}
            </div>
            <!-- <div class="ext-center login-url-links">
              {{ 'switchStaff' | translate  }}
            </div> -->
            <div class="text-center login-link">
              <span>{{ 'notRegistered' | translate  }} </span><span class="login-url-links"
                (click)="openRegisterLink()">{{
                'register' | translate 
                }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Forgot Password -->
      <div [ngClass]="{
      'login-container': isForgotPassword ,
      'show-and-hide-login-container': !isForgotPassword
    }">
        <div [ngClass]="{
          'login-sub-container': isForgotPassword,
          'login-sub-container-password': isForgotPassword 
        }">
          <div class="text-center login-text">
            <app-loader data="" loadingStyle="Dots" *ngIf="!loginSchoolLogo"></app-loader>
            <img src="{{ loginSchoolLogo }}" class="login-w-image school-logo" alt="school-logo"
              *ngIf="loginSchoolLogo" />
          </div>
          <div class="text-center login-heading ">
            {{
            'ForgotPassword' | translate 
            }}
          </div>
          <div class="login-message text-center">
            {{
            'createNewPassword' | translate 
            }}
          </div>
          <div class="form-group input-login-details email-input-container login-sub-container-password">
            <label for="url" [ngClass]="{
              'login-label-error': errorMessage.userEmail,
              'login-label': !errorMessage.userEmail
            }">{{ (isStaffLogin ? 'emailId' : 'usernameOrEmailId') | translate }}</label>
            <div class="domain-url-input-group">
              <input type="text" class="form-control" id="text" name="userEmail" [ngClass]="{
                'email-input': !errorMessage.userEmail,
                'email-input-error': errorMessage.userEmail
              }" minlength="2" maxlength="90" [(ngModel)]="userEmail" #emailAddress
                placeholder="{{ (isStaffLogin ? 'enterEmailId' : 'enterYourUsernameOrEmailId') | translate }}" (input)="handleDebounceEmail(emailAddress)"
                (keyup.enter)="isForgotPassword ? sendOptForForgotPassword(false): ''" />
              <div class="error-message">
                <span *ngIf="errorMessage.userEmail">
                  {{ errorMessage.userEmail }}</span>
              </div>
            </div>
          </div>
          <div class="login-btn text-center">
            <button class="btn btn-otp" type="submit" [disabled]="
          loader
       " (click)="sendOptForForgotPassword(false) ">
              <ng-container *ngIf="loader; else notLoading"><app-button-loader></app-button-loader></ng-container>
              <ng-template #notLoading>
                {{
                'sendOtp' | translate 
                }}
              </ng-template>
            </button>
          </div>
        </div>
      </div>
      <!-- Verify & Reset Password -->
      <div [ngClass]="{
        'login-container': isResetPassword ,
        'show-and-hide-login-container': !isResetPassword
      }">
        <div [ngClass]="{
            'login-sub-container': isResetPassword,
            'login-sub-container-password': isResetPassword 
          }">
          <div class="text-center login-text">
            <app-loader data="" loadingStyle="Dots" *ngIf="!loginSchoolLogo"></app-loader>
            <img src="{{ loginSchoolLogo }}" class="login-w-image school-logo" alt="school-logo"
              *ngIf="loginSchoolLogo" />
          </div>
          <div class="text-center login-heading ">
            {{
            'resetPassword' | translate 
            }}
          </div>
          <div class="login-message text-center">
            {{
            'verifyOtpAndSetNewPassword' | translate 
            }}
          </div>
          <div class="input-login-details otp-inputs-container">
            <input *ngFor="let digit of otpForForgotPassword; let i = index; trackBy: trackByIndex"
              id="send-otp-input-{{ i }}" name="send-otp-input-{{ i }}" type="text" maxlength="1"
              class="login-otp-input" [(ngModel)]="otpForForgotPassword[i]"
              [ngModelOptions]="{standalone: true}" (keyup)="moveToNextForForgotPasswordOTP($event, i)"
              (keydown)="handleKeyDown($event)" autocomplete="off"
              (keyup.enter)="i === otpForForgotPassword.length - 1 ? resetPassword() : ''" />
          </div>
          <div class="text-center">
            <button class="resend-otp-links" type="submit" [disabled]="loader || otpTime > 0 || countdown === 0"
              (click)="sendOptForForgotPassword(true)">
              {{ 'resendOtp' | translate  }}</button><span class="otp-timer-text">
              {{ 'in' | translate  }} {{ otpTime }} {{ 'sec' | translate  }} ({{
              countdown
              }}
              {{ 'resendAttempts' | translate  }} )</span>
          </div>
          <div class="form-group input-login-details password-visibility login-sub-container-password" [ngClass]="{
            }" *ngIf="isResetPassword">
            <label for="password" class="login-label">{{
              'newPassword' | translate 
              }}</label>
            <div class="password-input-group">
              <input class="form-control email-input" (input)="handleDebouncePassword(passwordInput)"
                [(ngModel)]="password" #passwordInput placeholder="{{ 'enterNewPassword' | translate  }}" id="password"
                name="password" type="password" (keyup.enter)="
                isResetPassword ? resetPassword() : ''
              " />
              <span class="password-icon">
                <img src="../../assets/img/password-icon.svg" alt="Password Icon" />
              </span>
            </div>
            <div class="form-group input-login-details password-visibility" [ngClass]="{
              'password-visibility': isResetPassword,
              show: isResetPassword
            }" *ngIf="isResetPassword">
              <label for="password" class="login-label">{{
                'confirmPassword' | translate 
                }}</label>
              <div class="password-input-group">
                <input class="form-control email-input" (input)="handleDebounceConfirmPassword(confirmNewPasswordInput)"
                  [(ngModel)]="confirmNewPassword" #confirmNewPasswordInput
                  placeholder="{{ 'enterConfirmPassword' | translate  }}" id="password" name="password" type="password"
                  (keyup.enter)="
                isResetPassword ? resetPassword() : ''
              " />
                <span class="password-icon">
                  <img src="../../assets/img/password-icon.svg" alt="Password Icon" />
                </span>
              </div>
            </div>
            <div class="login-btn text-center">
              <button class="btn btn-otp" type="submit" [disabled]="
            loader
         " (click)="resetPassword() ">
                <ng-container *ngIf="loader; else notLoader"><app-button-loader></app-button-loader></ng-container>
                <ng-template #notLoader>
                  {{
                  'submit' | translate 
                  }}
                </ng-template>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-school-details *ngIf="notVerifiedSchoolDetails"></app-school-details>

    <div class="qr-modal-overlay" *ngIf="showQrCodeModal" (click)="closeQrCodeLogin()">
      <div class="qr-modal" (click)="$event.stopPropagation()">
        <button type="button" class="qr-modal-close" (click)="closeQrCodeLogin()">
          <i class="ri-close-line"></i>
        </button>
        <h3 class="qr-modal-title">{{ 'loginWithQrCode' | translate }}</h3>

        <ol class="qr-modal-steps">
          <li>{{ 'qrStepOpenApp' | translate:{ brandName: brand.name } }}</li>
          <li>{{ 'qrStepTapIcon' | translate }}</li>
          <li>{{ 'qrStepScanCode' | translate }}</li>
        </ol>

        <div class="qr-modal-body">
          <div class="qr-modal-loader" *ngIf="qrCodeLoading">
            <app-button-loader></app-button-loader>
          </div>

          <div class="qr-modal-loader qr-modal-signing-in" *ngIf="qrCodeSignInLoading">
            <app-button-loader></app-button-loader>
            <p class="qr-modal-signing-in-text">{{ 'signingYouIn' | translate }}</p>
          </div>

          <ng-container *ngIf="!qrCodeLoading && !qrCodeSignInLoading && qrCodeImageUrl && !qrCodeExpired">
            <div class="qr-modal-image-frame">
              <img [src]="qrCodeImageUrl" class="qr-modal-image" alt="QR Code" />
            </div>
            <div class="qr-modal-timer">
              <i class="ri-time-line"></i> {{ 'qrCodeExpiresIn' | translate }} {{ qrCodeTimerDisplay }}
            </div>
          </ng-container>

          <div class="qr-modal-expired" *ngIf="!qrCodeLoading && !qrCodeSignInLoading && qrCodeExpired">
            <i class="ri-time-line qr-modal-expired-icon"></i>
            <p class="qr-modal-expired-text">{{ 'qrCodeExpired' | translate }}</p>
            <button type="button" class="btn-qr-refresh" (click)="refreshQrCodeLogin()">
              {{ 'refreshQrCode' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>